import Component from 'vue-class-component'
import { Vue } from 'vue-property-decorator'

@Component
class SnackbarService extends Vue {
  notify(notification: any) {
    const id = new Date().getTime()
    const timeout = notification.timeout ? notification.timeout : 6000
    const type = notification.type ? notification.type : 'error'
    let icon = type
    if (type === 'success') {
      icon = 'check_circle'
    }
    this.$store.state.snackbars.push({
      show: true,
      text: notification.text,
      type,
      timeout: 400000,
      id,
      icon
    })
    setTimeout(() => {
      this.unNotify(id)
    }, timeout)
  }

  unNotify(id: number) {
    this.$store.state.snackbars = this.$store.state.snackbars.filter(
      (s: any) => s.id !== id
    )
  }

  notifyPermanent(notification: any, id: string) {
    // return if id is already present
    if (this.$store.state.snackbars.find((s: any) => s.id === id)) {
      return
    }
    const type = notification.type ? notification.type : 'error'
    this.$store.state.snackbars.push({
      show: true,
      text: notification.text,
      type,
      timeout: 0,
      id,
      icon: 'info'
    })
  }

  unNotifyPermanent(id: string) {
    this.$store.state.snackbars = this.$store.state.snackbars.filter(
      (s: any) => s.id !== id
    )
  }
}
export default SnackbarService
